import { LandingPage } from "@/components/landing/LandingPage";

// `/` for unauthenticated visitors. The signed-in redirect to
// `/simulator` is handled by App.tsx's RootRedirect. Defers all
// marketing copy to the legacy `LandingPage` component so visual
// parity is exact.
export function Landing() {
  return <LandingPage />;
}
